import { connect } from "react-redux";
import { GlobalWaiter } from "../components/GlobalWaiter";
function mapStateToProps({ kptable }, { id }) {
    return {
        globalProgress: kptable[id].globalProgress,
        globalShowProgress: kptable[id].globalShowProgress,
        globalWaiting: kptable[id].globalWaiting,
    };
}
function mapDispatchToProps(_dispatch) {
    return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(GlobalWaiter);
